<article class="reward-rule-card" [class.reward-rule-card--inactive]="!rule.is_active">
  <header class="reward-rule-card__header">
    <div class="reward-rule-card__title-row">
      <h3 class="reward-rule-card__title">{{ rule.name }}</h3>
      <span *ngIf="!rule.is_active" class="reward-rule-card__status-chip">Disabled</span>
    </div>
    <div class="reward-rule-card__actions">
      <button
        *ngIf="rule.is_active"
        type="button"
        class="reward-rule-card__icon reward-rule-card__icon--edit"
        title="Edit"
        aria-label="Edit reward"
        (click)="editClick.emit(rule)">
        <span class="reward-rule-card__icon-glyph reward-rule-card__icon-glyph--edit" aria-hidden="true"></span>
      </button>
      <button
        *ngIf="rule.is_active"
        type="button"
        class="reward-rule-card__icon reward-rule-card__icon--disable"
        title="Disable"
        aria-label="Disable reward"
        (click)="disableClick.emit(rule)">
        <span class="reward-rule-card__icon-glyph reward-rule-card__icon-glyph--disable" aria-hidden="true"></span>
      </button>
    </div>
  </header>

  <div class="reward-rule-card__fields" role="list">
    <div class="reward-rule-card__field" role="listitem">
      <span class="reward-rule-card__label">Reward amount</span>
      <span class="reward-rule-card__value">{{ rewardAmount }}</span>
    </div>
    <div class="reward-rule-card__field" role="listitem">
      <span class="reward-rule-card__label">Service</span>
      <span class="reward-rule-card__value">{{ serviceLabel }}</span>
    </div>
    <div class="reward-rule-card__field" role="listitem">
      <span class="reward-rule-card__label">Wash type</span>
      <span class="reward-rule-card__value">{{ washTypeLabel }}</span>
    </div>
    <div class="reward-rule-card__field" role="listitem">
      <span class="reward-rule-card__label">Items required</span>
      <span class="reward-rule-card__value">{{ itemsRequiredLabel }}</span>
    </div>
  </div>
</article>
